import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'antd';
import FastField from '../commons/FastField';
import AntCheckbox from '../commons/AntCheckbox';

const style = {
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'column',
    flexWrap: 'wrap',
  },
};

const CollapsesForm = ({ columns, onSubmit, itemsStyle }) => {
  return (
    <div style={style.container}>
      {columns.list.map(item => {
        const [key, label] = Object.entries(item)[0];
        return (
          <FastField
            key={key}
            name={key}
            label={label}
            component={AntCheckbox}
            itemStyle={itemsStyle}
          />
        );
      })}
      <Button type="primary" htmlType="submit" onClick={onSubmit}>
        Save
      </Button>
    </div>
  );
};

CollapsesForm.propTypes = {
  itemsStyle: PropTypes.shape({}),
  onSubmit: PropTypes.func.isRequired,
  columns: PropTypes.shape({
    list: PropTypes.arrayOf(PropTypes.shape({})),
  }),
};

CollapsesForm.defaultProps = {
  itemsStyle: null,
  columns: {},
};

export default CollapsesForm;
